"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiDialogContentTextOverrides = void 0;
var createMuiDialogContentTextOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            marginBottom: spacing(8),
        },
    });
};
exports.createMuiDialogContentTextOverrides = createMuiDialogContentTextOverrides;
//# sourceMappingURL=MuiDialogContentText.js.map